import { Input } from 'cd-eft/components/common/Input';
import { observer } from 'mobx-react';
import React, { Fragment, useEffect, useRef} from 'react';
import { FormulaBanner } from '../Common/FormulaBanner';
import {
  ResultsContainer,
  ImageContainer,
  DescriptionContainer,
  InputContainer,
  FormulaPrintModalContainer,
} from '../template/FormulaFormTemplates';
import { PumpDrainageVM } from './PumpDrainageVM';
import { Loader } from 'cd-eft/components/common/LoadingSpinner/LoadingSpinner';
import { RadioGroup } from 'cd-eft/components/common/RadioGroup';
import { ComboBox } from 'cd-eft/components/common/ComboBox';
import pdfLogo from 'cd-eft/assets/images/pdf-blue.svg';


const PumpDrainageComponent = (props) => {
    const vm = useRef(new PumpDrainageVM(props)).current;
    useEffect(() => {
      // on initial render, load form data - desc, img, help link
      vm.getFormData(`${props.section}_${props.title}_${props.id}`);
    }, []);
  return (
    <Fragment>
      <FormulaBanner title={vm.formulaTitle} help={vm.bannerHelpLink} />    
      <div className="formula-content row ">
        <InputContainer computeCallback={() => {vm.computePumpDrainage() }} printCallback={() => vm.launchAndExport()} isLoading={vm.isLoading} disableCompute={vm.disableComputeBtn} disablePrint={!vm.hasResults || vm.isLoading || vm.disablePrintBtn}>
        <h2 className='sections-heading'>General</h2> 
          <Input
            label="Drained Area (ac)"
            idAndName="drained-area"
            valid={!vm.formValidation.drainedArea}
            value={vm.pumpDrainageForm.drainedArea}
            className={vm.PumpDrainageErrorClass('drainedArea')}
            type="number"
            step={'0.01'}
            min={0}
            onChange={(e) => {vm.handleInputChange(e)}}
            onBlur={(e) =>vm.validateInput(e.target.name, parseFloat(e.target.value))}    
            onKeyDown={vm.handleOnKeyDown}    
          /> 
          <ComboBox
              idAndName="drainage-coeffs"
              label="Drainage Coefficient (in/ day)"
              aria-label="Drainage Coefficient (in/ day)"
              valid={!vm.formValidation.drainageCoeffs}
              value={vm.pumpDrainageForm.drainageCoeffs}
              onChange={(e) => {
                vm.handleInputChange(e);
              }}
               onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
              options={vm.drainageCoeffsOptions}
              errorMsg={''}
              required={true}
              className={`"drainageCoeffs${vm.PumpDrainageErrorClass('drainageCoeffs')}`}
            />
          <ComboBox
              idAndName="safty-factors"
              label="Safety Factor"
              aria-label="Safety Factor"
              valid={!vm.formValidation.saftyFactors}
              value={vm.pumpDrainageForm.saftyFactors}
              onChange={(e) => {
                vm.handleInputChange(e);
              }}
               onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
              options={vm.saftyFactorsOptions}
              errorMsg={''}
              required={true}
              className={`"safty-factors${vm.PumpDrainageErrorClass('saftyFactors')}`}
            />
           <ComboBox
              idAndName="pump-cycles-perHours"
              label="Pump Cycles (per hour)"
              aria-label="Pump Cycles (per hour)"
              valid={!vm.formValidation.pumpCyclesPerHours}
              value={vm.pumpDrainageForm.pumpCyclesPerHours}
              onChange={(e) => {
                vm.handleInputChange(e);
              }}
               onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
              options={vm.pumpCyclesPerHoursOptions}
              errorMsg={''}
              required={true}
              className={`"pumpCyclesPerHours${vm.PumpDrainageErrorClass('pumpCyclesPerHours')}`}
            />
          <h2 className='sections-heading'>Elevation</h2>  
          <Input
            label="Inlet Elevation (ft)"
            idAndName="inlet-elev"
            valid={!vm.formValidation.inletElev}
            value={vm.pumpDrainageForm.inletElev}
            className={vm?.PumpDrainageErrorClass('inletElev')}
            type="number"
            step={'0.01'}
            min={0}
            onChange={vm.handleInputChange}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            onKeyDown={vm.handleOnKeyDown}
          />
           <Input
            label="Outlet Elevation (ft)"
            idAndName="outlet-elev"
            valid={!vm.formValidation.outletElev}
            value={vm.pumpDrainageForm.outletElev}
            className={vm?.PumpDrainageErrorClass('outletElev')}
            type="number"
            step={'0.01'}
            min={0}
            onChange={vm.handleInputChange}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            onKeyDown={vm.handleOnKeyDown}
          />
          <Input
            label="Start Level (ft)"
            idAndName="start-level"
            valid={!vm.formValidation.startLevel}
            value={vm.pumpDrainageForm.startLevel}
            className={vm?.PumpDrainageErrorClass('startLevel')}
            type="number"
            step={'0.01'}
            min={0}
            onChange={vm.handleInputChange}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            onKeyDown={vm.handleOnKeyDown}
          />
            <RadioGroup
              labelId="solveFor-radio"
              items={[
                {
                  id: "sumpControl",
                  name: "sumpControl",
                  label:"Sump Area",
                  className: 'usa-radio__input--tile',
                  checked: vm.sumpControl,
                  onChange: vm.handleInputChange,
                },
                {
                  id: 'stopControl',
                  name: 'stopControl',
                  label: 'Stop Level',
                  className: 'usa-radio__input--tile',
                  checked: vm.stopControl,
                  onChange: vm.handleInputChange,
                },
              ]}
            />
          {vm.solveForControl === 1 ?
          <Input
            label="Stop Level (ft)"
            idAndName="stop-level"
            valid={!vm.formValidation.stopLevel}
            value={vm.pumpDrainageForm.stopLevel}
            className={vm?.PumpDrainageErrorClass('stopLevel')}
            type="number"
            step={'0.01'}
            min={0}
            onChange={vm.handleInputChange}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            onKeyDown={vm.handleOnKeyDown}
          />
          :
          <Input
            label="Sump Area (sq ft)"
            idAndName="sump-area"
            valid={!vm.formValidation.sumpArea}
            value={vm.pumpDrainageForm.sumpArea}
            className={vm?.PumpDrainageErrorClass('sumpArea')}
            type="number"
            step={'0.01'}
            min={0}
            onChange={vm.handleInputChange}
            onBlur={(e) => vm.validateInput(e.target.name, parseFloat(e.target.value))}
            onKeyDown={vm.handleOnKeyDown}
          />
        }
         </InputContainer >           
       <div className="col formula-information " >
              {vm.hasResults ? (
              <div className="row formula-results ">
                  <ResultsContainer>
                    <div className="col result-value-group">
                      <div className="row">
                        <div className="col-md-9 result-label">Capacity Q (cfs):</div>
                        <div className="col-md-3">{vm.pumpDrainageResults.flowQ}</div>
                      </div> 
                      {vm.pumpDrainageResults.sumpArea !== null ? 
                        <div className="row">
                        <div className="col-md-9 result-label">Sump Area (ft):</div>
                        <div className="col-md-3">{vm.pumpDrainageResults.sumpArea}</div>
                        </div> :
                        <div className="row">
                        <div className="col-md-9 result-label">Stop Level (ft):</div>
                        <div className="col-md-3">{vm.pumpDrainageResults.stopLevel}</div>
                        </div> 
                      }      
                      <div className="row">
                      <div className="col-md-9 result-label">Sump Dimensions (ft diameter or ft squared):</div>
                      <div className="col-md-3">{vm.pumpDrainageResults.dimensions}</div>
                      </div>    
                    </div>
                  </ResultsContainer> 
                  </div>
            ) : ''}    
          <div className="row formula-description">
            <DescriptionContainer>
              <p> 
                {vm.formDescription}
                &nbsp;
                <a target="_blank" href={vm.bannerHelpLink}>
                  Learn More
                  <img src={pdfLogo} alt={'PDF logo'} />
                </a>       
              </p>
            </DescriptionContainer>
          </div>
          <div className="row formula-images">
          
            <ImageContainer>
              <img
                className=""
                src={vm.image}
                alt={vm.hydraulicFormulaImageDescription}
                title={vm.formulaTitle}
              />
            </ImageContainer>
          </div>
       </div>
       {vm.isLoading && <Loader message={''} />}
      </div>
      <FormulaPrintModalContainer 
        vm={vm}
        inputs={vm.exportedInputs}
        results={vm.exportedResults}
        images={[vm.image]}
        formulaName={vm.formulaTitle}
      />
    </Fragment>
  );
};

export const PumpDrainageFormula = observer(PumpDrainageComponent);